import { render, staticRenderFns } from "./MenuItemSimple.vue?vue&type=template&id=6ffb3316"
import script from "./MenuItemSimple.vue?vue&type=script&lang=js"
export * from "./MenuItemSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports